module.exports = __webpack_public_path__ + "img/ai-img-p1.309c8558.png";